// extracted by mini-css-extract-plugin
export default {"topic":"trending_topic__ccLN2","trending_negative":"trending_trending_negative__G2vMp","trending_positive":"trending_trending_positive__ixb0d"};